<template>
   
  <div class="farm-select">
    <v-select v-if="filteredFarms.length" :label="$t('base.farm')" :options="filteredFarms" v-model="farm_id"
      @input="onFarmSelected" />
    <span v-else>
      поки ферм немає...
    </span>
  
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'FarmPanel',
  data: () => ({
    farm_id: null,
    company_id: null
  }),
  computed: {
    ...mapGetters('farms', [
      'farms'
    ]),
    filteredFarms () {
      const translatedFarmName = this.$t('base.farm_name')
      return [
        { id: '-1', name: translatedFarmName },
        ...this.farms
          .map(farm => ({
            'id': farm.id,
            'name': `${farm.name} (${farm.company.name})`
          }))
      ]
    }
  },
  mounted () {
    this.loadFarms().then(() => {
      this.farm_id = +this.$route.params.farm_id || '-1'
    })
  },
  methods: {
    ...mapActions('farms', [
      'loadFarms'
    ]),
    onFarmSelected (id) {
      const selectedFarm = this.farms.find(item => item.id === id)
      const companyId = selectedFarm ? selectedFarm.company.id : '-1'
      this.$emit('farm-selected', id, companyId)
    },
  },
  watch: {
    farm_id (id) {
      this.onFarmSelected(id)
    }
  }
}
</script>


<style lang="scss">
.farm-select {
  height: 7rem;
  display: flex;
  align-items: center;
  padding: 6rem 2.5rem;
  margin-bottom: 1rem;
  background-color: var(--color-surface);
  border-radius: 6px;
  .v-select-wrapper,
  .v-select {
    width: 100%;
  }
}
</style>